import { MockRowList } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * View 2 — `template.html:879`. Sáu hàng phân cấp, hàng `2.1` đang được chọn (viền `brand-200` +
 * bóng, dòng 885).
 *
 * `active` suy từ MÃ hàng chứ không phải chỉ số: thêm hay bớt một hàng ở copy thì hàng được
 * đánh dấu vẫn là đúng hàng đó.
 */
const ACTIVE_ROW_CODE = '2.1';

export function WbsView() {
  const wbs = useCopy().pm.wbs;

  return (
    <div>
      <div className="mb-[18px] text-title font-bold text-ink-900">{wbs.title}</div>

      <MockRowList
        rows={wbs.rows.map((row) => ({
          code: row.code,
          label: row.label,
          trailing: row.percent,
          level: row.level,
          tone: row.tone,
          active: row.code === ACTIVE_ROW_CODE,
        }))}
      />
    </div>
  );
}
